// sidebarConfig.js




export const getSidebarLinks = (user) => [
  {
    heading: "Dashboard",
    items: [
      {
        id: "dashboard",
        label: "Dashboard",
        icon: "fa-solid fa-chart-pie",
        type: "group",
        roles: ["SUPER_ADMIN", "ADMIN", "PMM", "PM"],
        children: [
          {
            id: "overview",
            label: "Overview",
            to: "/",
            roles: ["SUPER_ADMIN", "ADMIN", "PMM", "PM"],

          },
          {
            id: "balance-overview",
            label: "Balance Overview",
            to: "/dashboard/balance-overview",
            roles: ["SUPER_ADMIN", "ADMIN"],

          },
          {
            id: "system-configuration",
            label: "System Configuration",
            to: "/dashboard/system-configuration",
            roles: ["SUPER_ADMIN"],

          },

          {
            id: "invite-users",
            label: "Invite Users",
            to: "/dashboard/invite-users",
            roles: ["SUPER_ADMIN", "ADMIN"],

          },
          {
            id: "pending-approvals",
            label: "Pending Approvals",
            to: "/dashboard/pending-approvals",
            roles: ["SUPER_ADMIN"],

          },
          {
            id: "invites-list",
            label: "Invites List",
            to: "/dashboard/invites-list",
            roles: ["SUPER_ADMIN", "ADMIN"],

          },
          {
            id: "admins",
            label: "Admins List",
            to: "/dashboard/admins",
            roles: ["SUPER_ADMIN"],

          },
          {
            id: "pmm-list",
            label: "PMM List",
            to: "/dashboard/pmm-list",
            roles: ["SUPER_ADMIN", "ADMIN"]
          },
          {
            id: "pm-list",
            label: "PM List",
            to: "/dashboard/pm-list",
            roles: ["SUPER_ADMIN", "ADMIN"]
          },

        ]
      }
    ]

  },
  {
    heading: "PMM/PM Commissions",
    items: [
      {
        id: "Commissions",
        label: "Commissions",
        icon: "fa-solid fa-sack-dollar",
        type: "group",
        roles: ["SUPER_ADMIN", "ADMIN", "PMM", "PM"],
        children: [
          {
            id: "pm-pending",
            label: user?.role === "PM" ? "Pending Commissions" : "PM Pending",
            to: "/commissions/pm-pending",
            roles: ["SUPER_ADMIN", "ADMIN", "PM"],

          },
          {
            id: "pmm-pending",
            label: user?.role === "PMM" ? "Pending Payouts" : "PMM Pending",
            to: "/commissions/pmm-pending",
            roles: ["SUPER_ADMIN", "ADMIN", "PMM"],

          },
          {
            id: "incoming-commissions",
            label: user?.role === "PMM" ? "Payment History" : "Incoming Commissions",
            to: "/commissions/incoming-commissions",
            roles: ["SUPER_ADMIN", "ADMIN", "PMM"],

          },
          {
            id: "outgoing-commissions",
            label: "Outgoing Commissions",
            to: "/commissions/outgoing-commissions",
            roles: ["SUPER_ADMIN", "ADMIN"],

          },
        ]
      }
    ]

  },

  {
    heading: "Sales & Orders",
    items: [
      {
        id: "orders",
        label: "Orders",
        icon: "fa-solid fa-bag-shopping",
        type: "group", // 👈 HAS SUB LINKS
        children: [
          {
            id: "all-orders",
            label: "All Orders",
            to: "/orders/all-orders"
          },
          {
            id: "ordered",
            label: "Ordered",
            to: "/orders/all-orders?status=ORDERED"
          },
          {
            id: "reviewed",
            label: "Reviewed",
            to: "/orders/all-orders?status=REVIEWED"
          },
          {
            id: "pending-refunds",
            label: "Pending Refunds",
            to: "/orders/all-orders?status=DELIVERED"
          },
          {
            id: "on-hold",
            label: "On Hold",
            to: "/orders/all-orders?status=ON_HOLD"
          },
          {
            id: "refunded",
            label: "Refunded",
            to: "/orders/all-orders?status=REFUNDED"
          },
          {
            id: "reviewDeleted",
            label: "Deleted Reviews",
            to: "/orders/all-orders?status=REVIEW_DELETED"
          },
          {
            id: "canceled-orders",
            label: "Canceled Orders",
            to: "/orders/all-orders?status=CANCELLED"
          },
          {
            id: "commissioned-orders",
            label: "Commissioned Orders",
            to: "/orders/all-orders?status=COMMISSIONED"
          },
          {
            id: "completed-orders",
            label: "Completed Orders",
            to: "/orders/all-orders?status=COMPLETED"
          },
        ]
      },
      {
        id: "reservations",
        label: "Reservations",
        icon: "fa-solid fa-calendar-check",
        type: "link",
        to: "/reservations"
      },
      {
        id: "delayed-refunds",
        label: "Delayed Refunds",
        icon: "fa-solid fa-clock-rotate-left",
        type: "link",
        to: "/delayed-refunds"
      },
      {
        id: "order-reports",
        label: "Order Reports",
        icon: "fa-solid fa-file-invoice",
        type: "link",
        to: "/order-reports"
      },
    ]
  },
  {
    heading: "Product Control",
    items: [
      {
        id: "products",
        label: "Products",
        icon: "fa-solid fa-boxes-stacked",
        type: "group", // 👈 HAS SUB LINKS
        children: [
          {
            id: "add-product",
            label: "Add New",
            to: "/products/add-product",
            roles: ["PMM"]
          },

          {
            id: "all-products",
            label: "All Products",
            to: "/products/all-products"
          }
        ]
      },

    ]
  },
  {
    heading: "Reports & Blocked Mails",
    items: [
      {
        id: "create-reports",
        label: "Create Reports",
        icon: "fa-solid fa-file-excel",
        type: "link",
        to: "/create-excel-reports"
      },
      {
        id: "blocked-mails",
        label: "Blocked Mails",
        icon: "fa-solid fa-ban",
        type: "link",
        to: "/blocked-mails"
      },
    ]
  },
  {
    heading: "Account & Profile",
    items: [
      {
        id: "profile",
        label: "Profile",
        icon: "fa-regular fa-user",
        type: "link",
        to: "/profile"
      },
      {
        id: "change-password",
        label: "Change Password",
        icon: "fa-solid fa-lock",
        type: "link",
        to: "/change-password"
      },
    ]
  },
  {
    heading: "Support & Help",
    items: [
      {
        id: "Support",
        label: "Support",
        icon: "fa-solid fa-headset",
        type: "group",
        to: "/support"
      }
    ]
  },
  {
    heading: "Logout",
    items: [
      {
        id: "logout",
        label: "Logout",
        icon: "fa-solid fa-arrow-right-from-bracket",
        type: "logout",
      }
    ]
  },
];
